import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class CompetenceFilter {
  public search = ''
  public isTemplate = false
  public isGlobal: boolean | null = null
  public paging = new PaginationRequest()
}
